import { jsx as _jsx } from "react/jsx-runtime";
import { RichText as SitecoreRichText, useSitecore } from '@sitecore-content-sdk/nextjs';
const ComponentContent = (props)=>{
    const id = props.id;
    return /*#__PURE__*/ _jsx("div", {
        className: `component content ${props?.styles}`,
        id: id ? id : undefined,
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content",
            children: /*#__PURE__*/ _jsx("div", {
                className: "field-content",
                children: props.children
            })
        })
    });
};
export const Default = (props)=>{
    const { page } = useSitecore();
    const id = props.params.RenderingIdentifier;
    const routeContent = page.layout.sitecore.route?.fields?.Content;
    if (!(props.fields && props.fields.Content) && !routeContent) {
        return /*#__PURE__*/ _jsx("div", {
            className: `component content ${props?.params?.styles}`,
            id: id ? id : undefined,
            children: /*#__PURE__*/ _jsx("div", {
                className: "component-content",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "field-content",
                    children: "[Content]"
                })
            })
        });
    }
    const field = props.fields && props.fields.Content ? props.fields.Content : routeContent;
    return /*#__PURE__*/ _jsx(ComponentContent, {
        styles: props?.params?.styles,
        id: id,
        children: /*#__PURE__*/ _jsx(SitecoreRichText, {
            field: field
        })
    });
};
